<div class="rendition-delete-container">
  <div class="icon-container">
    <qr-icon [name]="ICON_WARNING" [color]="ICON_COLOR_WHITE"></qr-icon>
  </div>
  <ng-container [ngSwitch]="this.value?.type">
    <p *ngSwitchCase="'invoices'">
      El monto de las facturas del tipo "agente a la oficina"
      {{ listAgents.length > 1 ? "de" : "del" }}
      <b *ngFor="let a of listAgents; let i = index"
        >{{
          a +
            (i == listAgents.length - 1
              ? ""
              : i == listAgents.length - 2
              ? " y "
              : ", ")
        }}
      </b>
      no puede superar el de su comisión neta por lo que debe corregir las
      facturas ingresadas.
      <br />
      Si necesita más información por favor contacte a soporte.
    </p>
    <p *ngSwitchCase="'netcommissions'">
      El monto de la comisión neta
      {{ listAgents.length > 1 ? "de" : "del" }}
      <b *ngFor="let a of listAgents; let i = index"
        >{{
          a +
            (i == listAgents.length - 1
              ? ""
              : i == listAgents.length - 2
              ? " y "
              : ", ")
        }}
      </b>
      no puede ser negativo
    </p>
    <p *ngSwitchCase="'VOUCHER'">
      <strong>Existen facturas sin tipo de comprobante.</strong> Edítelas para
      poder continuar.
    </p>
  </ng-container>
</div>
